// Importar Bootstrap JavaScript
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Seu código JavaScript personalizado
document.addEventListener("DOMContentLoaded", function () {
  console.log("Tema WordPress com Bootstrap carregado!");

  // Inicializar tooltips do Bootstrap
  const tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Inicializar popovers do Bootstrap
  const popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  // Menu mobile responsivo
  const navbarToggler = document.querySelector(".navbar-toggler");
  if (navbarToggler) {
    navbarToggler.addEventListener("click", function () {
      const target = document.querySelector(
        this.getAttribute("data-bs-target")
      );
      if (target) {
        target.classList.toggle("show");
      }
    });
  }

  // Smooth scroll para links âncora
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Adicionar classe ativa aos links do menu baseado na URL atual
  const currentLocation = location.pathname;
  const menuItems = document.querySelectorAll(".navbar-nav .nav-link");
  menuItems.forEach((item) => {
    if (item.getAttribute("href") === currentLocation) {
      item.classList.add("active");
    }
  });

  // Funcionalidades do carrinho
  initCartFunctionality();

  // Busca de produtos
  initProductSearch();

  // Menu de categorias
  initCategoriesMenu();

  // Modal mobile de categorias
  initMobileCategoriesModal();

  // Header sticky
  initStickyHeader();

  // Dropdown enhancements
  initDropdownEnhancements();
});

// Funcionalidades do carrinho
function initCartFunctionality() {
  // Botões de quantidade no carrinho
  document.querySelectorAll(".quantity-btn").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const action = this.dataset.action;
      const cartKey = this.dataset.key;
      const quantitySpan = this.parentElement.querySelector(".quantity-value");
      let currentQuantity = parseInt(quantitySpan.textContent);

      if (action === "increase") {
        currentQuantity++;
      } else if (action === "decrease" && currentQuantity > 1) {
        currentQuantity--;
      }

      // Atualizar visualmente
      quantitySpan.textContent = currentQuantity;

      // Enviar via AJAX para atualizar o carrinho
      updateCartQuantity(cartKey, currentQuantity);
    });
  });

  // Botões de remover item
  document.querySelectorAll(".remove-item").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const cartKey = this.dataset.key;
      removeCartItem(cartKey);
    });
  });
}

// Atualizar quantidade do carrinho via AJAX
function updateCartQuantity(cartKey, quantity) {
  if (typeof ajax_object !== "undefined") {
    fetch(ajax_object.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "update_cart_quantity",
        cart_key: cartKey,
        quantity: quantity,
        nonce: ajax_object.nonce,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Atualizar contador do carrinho
          updateCartCounter(data.data.cart_count);
          // Atualizar subtotal
          updateCartSubtotal(data.data.subtotal);
        }
      })
      .catch((error) => {
        console.error("Erro ao atualizar carrinho:", error);
      });
  }
}

// Remover item do carrinho via AJAX
function removeCartItem(cartKey) {
  if (typeof ajax_object !== "undefined") {
    fetch(ajax_object.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "remove_cart_item",
        cart_key: cartKey,
        nonce: ajax_object.nonce,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Remover item visualmente
          const cartItem = document
            .querySelector(`[data-key="${cartKey}"]`)
            .closest(".cart-item");
          cartItem.remove();

          // Atualizar contador do carrinho
          updateCartCounter(data.data.cart_count);

          // Se carrinho vazio, mostrar mensagem
          if (data.data.cart_count === 0) {
            showEmptyCart();
          }
        }
      })
      .catch((error) => {
        console.error("Erro ao remover item:", error);
      });
  }
}

// Atualizar contador do carrinho
function updateCartCounter(count) {
  const cartCounter = document.querySelector(".cart-count");
  if (cartCounter) {
    cartCounter.textContent = count;
  }
}

// Atualizar subtotal do carrinho
function updateCartSubtotal(subtotal) {
  const subtotalElement = document.querySelector(
    ".cart-summary strong:last-child"
  );
  if (subtotalElement) {
    subtotalElement.textContent = subtotal;
  }
}

// Mostrar carrinho vazio
function showEmptyCart() {
  const cartContent = document.querySelector(".cart-content");
  if (cartContent) {
    cartContent.innerHTML = `
            <div class="empty-cart text-center p-4">
                <i class="fas fa-shopping-cart fa-3x text-muted mb-3"></i>
                <h5>Seu carrinho está vazio</h5>
                <p class="text-muted">Adicione produtos para começar suas compras</p>
                <a href="/loja" class="btn btn-primary">
                    Continuar Comprando
                </a>
            </div>
        `;
  }
}

// Header sticky
function initStickyHeader() {
  let lastScrollTop = 0;
  const header = document.querySelector(".site-header");
  const promoBar = document.querySelector(".promo-bar");

  if (header) {
    window.addEventListener("scroll", function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 800) {
        header.classList.add("sticky");
        if (promoBar) {
          promoBar.style.display = "none";
        }
      } else {
        header.classList.remove("sticky");
        if (promoBar) {
          promoBar.style.display = "block";
        }
      }

      lastScrollTop = scrollTop;
    });
  }
}

// Melhorias nos dropdowns
function initDropdownEnhancements() {
  // Fechar dropdown ao clicar fora
  document.addEventListener("click", function (e) {
    const dropdowns = document.querySelectorAll(".dropdown-menu.show");
    dropdowns.forEach((dropdown) => {
      if (!dropdown.parentElement.contains(e.target)) {
        dropdown.classList.remove("show");
        dropdown.previousElementSibling.setAttribute("aria-expanded", "false");
      }
    });
  });

  // Animação dos chevrons
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
    toggle.addEventListener("shown.bs.dropdown", function () {
      const chevron = this.querySelector(".fa-chevron-down");
      if (chevron) {
        chevron.style.transform = "rotate(180deg)";
      }
    });

    toggle.addEventListener("hidden.bs.dropdown", function () {
      const chevron = this.querySelector(".fa-chevron-down");
      if (chevron) {
        chevron.style.transform = "rotate(0deg)";
      }
    });
  });

  // Pesquisa focus enhancement
  const searchField = document.querySelector(".search-field");
  if (searchField) {
    searchField.addEventListener("focus", function () {
      this.parentElement.classList.add("focused");
    });

    searchField.addEventListener("blur", function () {
      this.parentElement.classList.remove("focused");
    });
  }
}

// Funcionalidades de busca de produtos
function initProductSearch() {
  const searchField = document.querySelector(".search-field");
  const searchForm = document.querySelector(".woocommerce-product-search");

  if (!searchField || !searchForm) return;

  let searchTimeout;
  let searchResults = null;

  // Criar container para resultados instantâneos
  const resultsContainer = document.createElement("div");
  resultsContainer.className = "search-results-dropdown";
  resultsContainer.style.cssText = `
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #e9ecef;
        border-top: none;
        border-radius: 0 0 12px 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 1000;
        display: none;
        max-height: 400px;
        overflow-y: auto;
    `;

  // Inserir container de resultados
  searchForm.style.position = "relative";
  searchForm.appendChild(resultsContainer);

  // Busca instantânea (debounced)
  searchField.addEventListener("input", function () {
    const searchTerm = this.value.trim();

    clearTimeout(searchTimeout);

    if (searchTerm.length < 2) {
      hideSearchResults();
      return;
    }

    searchTimeout = setTimeout(() => {
      performInstantSearch(searchTerm);
    }, 300);
  });

  // Esconder resultados ao perder foco
  searchField.addEventListener("blur", function () {
    setTimeout(() => {
      hideSearchResults();
    }, 200);
  });

  // Mostrar resultados ao focar (se houver busca)
  searchField.addEventListener("focus", function () {
    if (this.value.trim().length >= 2 && searchResults) {
      showSearchResults();
    }
  });

  // Função para busca instantânea
  function performInstantSearch(searchTerm) {
    if (typeof ajax_object === "undefined") return;

    fetch(ajax_object.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "ajax_product_search",
        search_term: searchTerm,
        nonce: ajax_object.nonce,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          displaySearchResults(data.data);
          searchResults = data.data;
        }
      })
      .catch((error) => {
        console.error("Erro na busca:", error);
      });
  }

  // Exibir resultados
  function displaySearchResults(products) {
    if (!products || products.length === 0) {
      resultsContainer.innerHTML = `
                <div class="search-no-results p-3 text-center">
                    <i class="fas fa-search text-muted mb-2"></i>
                    <p class="mb-0 text-muted">Nenhum produto encontrado</p>
                </div>
            `;
    } else {
      resultsContainer.innerHTML = products
        .map(
          (product) => `
                <div class="search-result-item p-3 border-bottom" style="cursor: pointer;" onclick="window.location='${
                  product.url
                }'">
                    <div class="d-flex align-items-center">
                        ${
                          product.image
                            ? `<img src="${product.image}" alt="${product.title}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 8px; margin-right: 12px;">`
                            : ""
                        }
                        <div class="flex-grow-1">
                            <h6 class="mb-1" style="font-size: 0.9rem; line-height: 1.3;">${
                              product.title
                            }</h6>
                            <div class="text-primary fw-bold" style="font-size: 0.9rem;">${
                              product.price
                            }</div>
                        </div>
                        <i class="fas fa-arrow-right text-muted"></i>
                    </div>
                </div>
            `
        )
        .join("");

      // Adicionar link "Ver todos os resultados"
      resultsContainer.innerHTML += `
                <div class="search-all-results p-3 text-center bg-light">
                    <button type="submit" class="btn btn-link text-primary fw-bold" style="text-decoration: none;">
                        <i class="fas fa-search me-2"></i>Ver todos os resultados
                    </button>
                </div>
            `;
    }

    showSearchResults();
  }

  // Mostrar container de resultados
  function showSearchResults() {
    resultsContainer.style.display = "block";
    searchField.parentElement.style.borderRadius = "12px 12px 0 0";
  }

  // Esconder container de resultados
  function hideSearchResults() {
    resultsContainer.style.display = "none";
    searchField.parentElement.style.borderRadius = "25px";
  }

  // Adicionar hover nos itens
  resultsContainer.addEventListener("mouseover", function (e) {
    const item = e.target.closest(".search-result-item");
    if (item) {
      item.style.backgroundColor = "#f8f9fa";
    }
  });

  resultsContainer.addEventListener("mouseout", function (e) {
    const item = e.target.closest(".search-result-item");
    if (item) {
      item.style.backgroundColor = "";
    }
  });
}

// Menu de categorias com hover (desktop)
function initCategoriesMenu() {
  const categoryItems = document.querySelectorAll(
    ".category-nav-item.has-dropdown"
  );

  categoryItems.forEach((item) => {
    const dropdown = item.querySelector(".category-dropdown");
    let hoverTimeout;

    if (!dropdown) return;

    // Mostrar dropdown no hover
    item.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
      dropdown.style.opacity = "1";
      dropdown.style.visibility = "visible";
      dropdown.style.transform = "translateY(0)";
    });

    // Esconder dropdown ao sair (com delay)
    item.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(() => {
        dropdown.style.opacity = "0";
        dropdown.style.visibility = "hidden";
        dropdown.style.transform = "translateY(-10px)";
      }, 150);
    });

    // Manter dropdown visível quando hover nele
    dropdown.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
    });

    dropdown.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(() => {
        dropdown.style.opacity = "0";
        dropdown.style.visibility = "hidden";
        dropdown.style.transform = "translateY(-10px)";
      }, 150);
    });
  });
}

// Modal mobile de categorias
function initMobileCategoriesModal() {
  const subcategoryToggles = document.querySelectorAll(".subcategory-toggle");

  subcategoryToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();

      const categoryItem = this.closest(".mobile-category-item");
      const subcategoriesMenu = categoryItem.querySelector(
        ".subcategories-mobile"
      );
      const icon = this.querySelector("i");

      if (subcategoriesMenu) {
        const isVisible = subcategoriesMenu.style.display === "block";

        // Fechar outros submenus
        subcategoryToggles.forEach((otherToggle) => {
          if (otherToggle !== toggle) {
            const otherCategoryItem = otherToggle.closest(
              ".mobile-category-item"
            );
            const otherSubcategoriesMenu = otherCategoryItem?.querySelector(
              ".subcategories-mobile"
            );
            const otherIcon = otherToggle.querySelector("i");

            if (otherSubcategoriesMenu) {
              otherSubcategoriesMenu.style.display = "none";
            }
            if (otherIcon) {
              otherIcon.style.transform = "rotate(0deg)";
            }
            otherToggle.classList.remove("active");
          }
        });

        // Toggle atual
        if (isVisible) {
          subcategoriesMenu.style.display = "none";
          icon.style.transform = "rotate(0deg)";
          this.classList.remove("active");
        } else {
          subcategoriesMenu.style.display = "block";
          icon.style.transform = "rotate(180deg)";
          this.classList.add("active");
        }
      }
    });
  });

  // Fechar modal ao clicar em links
  const categoryLinks = document.querySelectorAll(
    "#categoriesModal .category-main-link, #categoriesModal .subcategory-mobile-link, #categoriesModal .view-all-link"
  );
  const modal = document.getElementById("categoriesModal");

  categoryLinks.forEach((link) => {
    link.addEventListener("click", function () {
      // Fechar modal
      const modalInstance = bootstrap.Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide();
      }
    });
  });

  // Reset modal ao fechar
  modal?.addEventListener("hidden.bs.modal", function () {
    // Fechar todos os submenus
    const allSubcategoriesMenus = modal.querySelectorAll(
      ".subcategories-mobile"
    );
    const allToggleIcons = modal.querySelectorAll(".subcategory-toggle i");
    const allToggles = modal.querySelectorAll(".subcategory-toggle");

    allSubcategoriesMenus.forEach((menu) => {
      menu.style.display = "none";
    });

    allToggleIcons.forEach((icon) => {
      icon.style.transform = "rotate(0deg)";
    });

    allToggles.forEach((toggle) => {
      toggle.classList.remove("active");
    });
  });
} // Importar Bootstrap JavaScript
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Seu código JavaScript personalizado
document.addEventListener("DOMContentLoaded", function () {
  console.log("Tema WordPress com Bootstrap carregado!");

  // Inicializar tooltips do Bootstrap
  const tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Inicializar popovers do Bootstrap
  const popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  // Menu mobile responsivo
  const navbarToggler = document.querySelector(".navbar-toggler");
  if (navbarToggler) {
    navbarToggler.addEventListener("click", function () {
      const target = document.querySelector(
        this.getAttribute("data-bs-target")
      );
      if (target) {
        target.classList.toggle("show");
      }
    });
  }

  // Smooth scroll para links âncora
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Adicionar classe ativa aos links do menu baseado na URL atual
  const currentLocation = location.pathname;
  const menuItems = document.querySelectorAll(".navbar-nav .nav-link");
  menuItems.forEach((item) => {
    if (item.getAttribute("href") === currentLocation) {
      item.classList.add("active");
    }
  });
});
